import React from "react";
import { Tag } from "antd";
import { CheckOutlined } from "@ant-design/icons";

export const CompletedTag: React.FC = (props) => {
  return (
    <Tag icon={<CheckOutlined />} color="default" style={{ margin: 0 }}>
      Completed
    </Tag>
  );
};
